import React, { useState, useEffect } from 'react';
import vr from '../../../../../../utils/Verifiers';
import { dateFormatConDiaShort } from '../../../../../../utils/DateFunctions';
import CloseButton from '../../../../../sharecomponents/CloseButton';
const ListaPlanesItinerarioCama = (p) => {
    const cama = p.cama ?? { planes: [] };
    console.log(cama);
    useEffect(() => {

    }, []);

    const cerrarDandoClic = (e) => {
        if (e.target.id === 'lista-planes-itinerario-cama') return;
        p.close();
    }

    return (
        <div className='bg-white4 blur-m p-2 contenedor lh1' style={{ width: "100vw", height: "100vh", position: "fixed", top: 0, left: 0, zIndex: 99999 }} onClick={(e) => cerrarDandoClic(e)}>
            <div className='row justify-content-center w-100 m-0 p-0'>
                <div className='col-lg-12 text-end m-0 p-0' style={{ position: 'fixed', right: "20px", top: "20px" }}>
                    <CloseButton close={() => p.close()} floatElement={true} />
                </div>

                <div className='bw-1200 overflow m-0 p-0 bg-white shadow rounded p-3' id='lista-planes-itinerario-cama'>
                    <div className='col-lg-12 text-center h1 text-300'>Cama #{cama.cama} <span className='ms-4 text-m text-bold'>{cama.ocupado_metros} de {cama.total_metros} Metros ocupados</span></div>
                    <table className='table table-sm table-striped'>
                        <thead>
                            <tr>
                                <th scope='col' className='text-center text-m nowrap'>Bloque</th>
                                <th scope='col' className='text-center text-m nowrap'>Espacio</th>
                                <th scope='col' className='text-center text-m nowrap'>Desde</th>
                                <th scope='col' className='text-center text-m nowrap'>Hasta</th>
                                <th scope='col' className='text-center text-m nowrap'>plantas</th>
                            </tr>
                        </thead>
                        <tbody>
                            {cama.planes.map((plan, index) => (
                                <tr key={index}>
                                    <th scope='row' className='nowrap' >{plan.bloque}</th>
                                    <td className='text-center text-green3 nowrap pe-3'>
                                        {plan.metros_plan}<span className='text-xs'>metros plan</span><span className='text-300 ms-4 me-4 opacity-50'>|</span>
                                        {plan.metros}<span className='text-xs'>metros cama</span><span className='text-300 ms-4 me-4 opacity-50'>|</span>{(Math.round(plan.porcentaje * 10000) / 100).toFixed(2)}%
                                    </td>
                                    <td className='text-center text-blue3 nowrap ps-3 pe-3'>
                                        {plan.semana_trasplante}-{plan.dia_trasplante}<span className='text-300 ms-4 me-4 opacity-50'>|</span>{dateFormatConDiaShort(plan.fecha_inicio)}
                                    </td>
                                    <td className='text-center text-red3 nowrap ps-3 pe-3'>
                                        {plan.semana_cosecha}-{plan.dia_cosecha}<span className='text-300 ms-4 me-4 opacity-50'>|</span>{dateFormatConDiaShort(plan.fecha_fin)}
                                    </td>
                                    <td className='text-center  nowrap ps-3'>
                                        {plan.plantas} pl. <span className='text-300 ms-4 me-4 opacity-50'>|</span>Densidad: {Math.round(plan.plantas / plan.metros_plan * 100) / 100}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <div className='col-lg-12 text-center h3 text-300'>
                        {Math.round(cama.ocupado_porcentaje * 10000) / 100}% <span className='ms-1 text-s text-bold'>De su capacidad</span>
                        <span className='ms-5'>{Math.round(Math.max(0, cama.total_metros - cama.ocupado_metros) * 100) / 100}</span> <span className='ms-1 text-m text-bold'>Metros Libres</span></div>
                </div>
            </div>
        </div>
    )
}

export default ListaPlanesItinerarioCama;